import React, { Component } from 'react';
import logo from '../assets/logo.png';
import logo2 from '../assets/logo2.png';
import { Link } from 'react-router-dom';




class Test270926 extends Component {
  state = { walletInfo: {} };
  render() {
    const { address, balance } = this.state.walletInfo;
    return (
      <div className='RosterThursday2'>
      <img className='logo' src={logo}></img>
      <br />
      <h3>Examination 27/09/2026 Candidates(Sattahip)</h3>
      <br />
      <br />


        <div><Link to='/conduct-ratchadapornn'>1. AAT 7822  MS.RATCHADAPORN NONNUSAT(2KYU)---Trying for 1KYU</Link></div>
        <br />
        <div><Link to='/conduct-napolp'>2. ATT  7910  MR.NAPOL PITAYAPAT(Tested at Chula)---Acquired Rank SHODAN-HO***</Link></div>
        <br />
        <div><Link to='/conduct-asdawutc'>3. ATT  7925  LT.ASDAWUT CHODSAPTHAWEE(4KYU)---Trying for 3KYU</Link></div>
        <br />
        <div><Link to='/conduct-thomasm'>4. AAT 7923  MR.THOMAS MOENKEMEIER(4KYU)---Trying for 3KYU</Link></div>
        <br />
        <div><Link to='/conduct-nirunc'>5. AAT 7783  LT.NIRUN CHANTAWARO(5KYU)---Trying for 4KYU</Link></div>
        <br />
        <div><Link to='/conduct-sunyal'>6. AAT 7972  CPO1.SUNYA LAEID(5KYU)---Trying for 4KYU</Link></div>
        <br />
        <div><Link to='/conduct-chakchaia'>7. AAT  8022  1st LT.CHAKCHAI ANUPONGPAT(8KYU)---Trying for 7KYU</Link></div>
        <br />
        <div><Link to='/conduct-barbarab'>8. AAT 8027  MS.BARBARA BARZARKINA(8KYU)---Trying for 7KYU</Link></div>
        <br />
        <div><Link to='/conduct-panyasuphak'>9. AAT 8029  MS.PANYASUPHA KHEMARUT(8KYU)---Trying for 7KYU</Link></div>
        <br />
        <div><Link to='/conduct-nueas'>10. AAT 8006  MS.NUEA SUDRAK(8KYU)---Trying for 7KYU</Link></div>
        <br />
        <div><Link to='/conduct-zaidena'>11. AAT 8044  MR.ZAIDEN ANDERSSON(9KYU)---Trying for 8KYU</Link></div>
        <br />
        <div><Link to='/conduct-andrewl'>12. AAT 7973  MR.ANDREW LINDQVIST(9KYU)---Trying for 8KYU</Link></div>
        <br />
        <div><Link to='/conduct-benjaminb'>13. AAT 8045  MR.BENJAMIN BROWN(9KYU)---Trying for 8KYU</Link></div>
        <br />
        <div><Link to='/conduct-tylerb'>14. AAT 8046  MR.TYLER BROWN(9KYU)---Trying for 8KYU</Link></div>
        <br />
        <div><Link to='/conduct-wyonab'>15. AAT 8047  MS.WYONA BROWN(9KYU)---Trying for 8KYU</Link></div>
        <br />
        <div><Link to='/conduct-jaiklal'>16. AAT 8067  MR.JAIKLA LORGUNPAI(10KYU)---Trying for 9KYU</Link></div>
        <br />
        <div><Link to='/conduct-pittayac'>17. AAT 8077  MR.PITTAYA CHAMNANPOOD(WHITE BELT)---Trying for 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-pordeer'>18. AAT 8078  MS.PORDEE RATTANARAK(WHITE BELT)---Trying for 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-pemikar'>19. AAT 8079  MS.PEMIKA RATTANA(WHITE BELT)---Trying for 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-pattarapony'>20. AAT 8080  MR.PATTARAPON YOUNGHAIPON(WHITE BELT)---Trying for 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-piyanats'>21. AAT 8081  MR.PIYANAT SUPATTHANAKORNKIT(WHITE BELT)---Trying for 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-ratchaninp'>22. AAT 8082  MS.RATCHANIN PEEPANICH(WHITE BELT)---Trying for 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-natnateep'>23. AAT 8083  MR.NATNATEE PEEPANICH(WHITE BELT)---Trying for 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-bowwonlukc'>24. AAT 8084  MS.BOWWONLUK CHAMNANPOOD(WHITE BELT)---Trying for 10KYU</Link></div>
        <br />


        <div>
          Thailand's Aikido Association Registration...
        </div>
          <br />
          <br />
        <div>Powered by</div><img className='logo2' src={logo2}></img><div>New Wave Consulting Group</div>
      </div>
    );
  }
}
export default Test270926;
